<template>
  <section>
    <div class="po-f sidebar">
      <el-badge class="w100 mt10" :value="msgCount.need" :hidden="msgCount.need < 1" :max="99" type="warning">
        <div class="flex-box al-c cu-p sidebar-item" @click="showDialog('needDialog')">
          <img :src="`${baseUrl}images/icon-home-daiban.png`">
          <span class="ml10 font-16">待处理</span>
        </div>
      </el-badge>
      <!-- <el-badge class="w100 mt10" :value="msgCount.done" :hidden="msgCount.done < 1" :max="99" type="warning"> -->
      <el-badge class="w100 mt10" :value="msgCount.done" hidden type="warning">
        <div class="flex-box al-c cu-p sidebar-item" @click="showDialog('doneDialog')">
          <img :src="`${baseUrl}images/icon-home-yiban.png`">
          <span class="ml10 font-16">已处理</span>
        </div>
      </el-badge>
      <!-- <el-badge class="w100 mt10" :value="msgCount.launch" :hidden="msgCount.launch < 1" :max="99" type="warning"> -->
      <el-badge class="w100 mt10" :value="msgCount.launch" hidden type="warning">
        <div class="flex-box al-c cu-p sidebar-item" @click="showDialog('launchDialog')">
          <img :src="`${baseUrl}images/icon-home-faqi.png`">
          <span class="ml10 font-16">我发起</span>
        </div>
      </el-badge>
    </div>
    <DialogNeed ref="needDialog" @fetch-msg-count="fetchMsgCount" />
    <DialogDone ref="doneDialog" @fetch-msg-count="fetchMsgCount" />
    <DialogLaunch ref="launchDialog" @fetch-msg-count="fetchMsgCount" />
  </section>
</template>

<script>
import DialogNeed from "@/components/messageBox/DialogNeed";
import DialogDone from "@/components/messageBox/DialogDone";
import DialogLaunch from "@/components/messageBox/DialogLaunch";

export default {
  name: "Sidebar",
  components: {
    DialogNeed,
    DialogDone,
    DialogLaunch
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      msgCount: {
        need: 0,
        done: 0,
        launch: 0
      },
      loopFetch: null
    };
  },
  computed: {},
  created() {
    this.fetchMsgCount();
  },
  mounted() {},
  destroyed() {
    this.stopLoopFetch();
  },
  methods: {
    fetchMsgCount() {
      this.stopLoopFetch();
      this.$http
        .get("/baseTask/taskCount")
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.msgCount.need = data.resData.toDoTaskTotal;
            this.msgCount.done = data.resData.hasDoneTaskTotal;
            this.msgCount.launch = data.resData.hasLaunchTotal;

            this.loopFetch = setTimeout(() => {
              this.fetchMsgCount();
            }, 60000);
          }
        })
        .catch(() => {});
    },
    stopLoopFetch() {
      if (this.loopFetch) {
        window.clearTimeout(this.loopFetch);
      }
    },
    showDialog(refName) {
      this.$refs[refName].showView();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.sidebar {
  left: 0;
  top: 50%;
  width: 124px;
  z-index: 50;
}

.sidebar-item {
  padding: 0 10px 0 16px;
  height: 40px;
  background: #fff;
  border: 1px solid #eee;
  border-left: none;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
}

.sidebar-item:hover {
  color: #2e67be;
  background: #e4f1fe;
}
</style>
